import styled from '@emotion/styled';
import { FormGroup, spacer8, spacer48 } from '@spotify-internal/encore-web';

// TODO https://anchorfm.atlassian.net/browse/WHEEL-832: Figure out if Encore has a better way of horizontally aligning form labels and inputs
export const HorizontalFormGroup = styled(FormGroup)`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  padding-bottom: ${spacer48};

  label {
    width: 100%;
    margin: 0;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
  width: 100%;
  padding-top: ${spacer8};
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const Label = styled.span`
  flex: 1;
`;

export const ProviderUrl = styled.span`
  font-weight: normal;
`;
